import { Model as BaseModel } from 'vue-api-query'

export default class Model extends BaseModel
{
    baseURL ()
    {
        return window.config.apiUrl;
        //return 'http://localhost:8000/api/groovemember';
    }

    request (config)
    {
        return this.$http.request(config)
    }
}
